import ProjectCard from './ProjectCard';
import useProjects from './useProjects';
import { useTranslation } from 'react-i18next';
import styles from './Portfolio.module.css';

const ProjectsPage = () => {
  const { t } = useTranslation();
  const projects = useProjects();
  return <div className={styles.pageWrap}>
    <header className={styles.pageHero}>
      <p className={styles.eyebrow}>{t('projects.eyebrow')}</p>
      <h1>{t('projects.title')}</h1>
      <p>{t('projects.description')}</p>
    </header>
    <div className={styles.projectsGrid}>
      {projects.map((project) => (
        <ProjectCard key={project.slug} project={project} />
      ))}
    </div>
  </div>;
};

export default ProjectsPage;
